module.exports = __webpack_public_path__ + "img/home9.4a3fb29f.png";